export default __webpack_public_path__ + "static/media/published-project.1aa6a5d7.jpg";